import _ from 'lodash';
import { isPageComponent } from './utils';
export const updateParentBackgroundColor = (parentComponent, backgroundColor) => {
  if (isPageComponent(parentComponent)) {
    const {
      style
    } = parentComponent;
    const properties = style == null ? void 0 : style.style.properties;
    if (properties != null && properties.bg && _.toFinite(properties == null ? void 0 : properties['alpha-bg']) > 0) {
      properties.bg = backgroundColor;
      return {
        ...parentComponent,
        style
      };
    }
    const {
      data
    } = parentComponent;
    data.pageBackgrounds.desktop.ref.color = backgroundColor;
    return {
      ...parentComponent,
      data
    };
  }
  return parentComponent;
};
//# sourceMappingURL=update-parent-background-color.js.map